import React, { Fragment } from "react";
import { connect } from "formik";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import _ from "lodash";

import { StyledPercentInput, StyledDecimalInput } from "../styles";

import FormSectionTitle from "./FormSectionTitle";

const ConstraintsSection = ({ formik }) => {
  const { values } = formik;

  return (
    <>
      <Grid item xs={12}><FormSectionTitle title="CONSTRAINTS" /></Grid>
      <Grid item xs={3}>
        <StyledDecimalInput label="DSCR" decimalScale={3} fieldName="dscr" />
        {" "}
      </Grid>
      <Grid item xs={3}>
        <StyledPercentInput label="Max LTV" decimalScale={3} fieldName="maxLTV" />
        {" "}
      </Grid>
      <Grid item xs={3}>
        <StyledPercentInput label="Debt Yield" decimalScale={3} fieldName="debtYield" />
        {" "}
      </Grid>
    </>
  );
};
export default compose(
  connect
)(ConstraintsSection);
